import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'bp-spinning-logo',
	templateUrl: './spinning-logo.component.html',
	styleUrls: [ './spinning-logo.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinningLogoComponent { }
